<!-- =========================================================================================
	File Name: ECommerceWishList.vue
	Description: eCommerce Wish List Page
	----------------------------------------------------------------------------------------
	Item Name: Vuesax Admin - VueJS Dashboard Admin Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="match-list">
    <vx-card>
      <vs-tabs v-model="tabsIndex">
        <vs-tab :label="tabs[0]" :style="{padding:'30px 10px'}" @click="getList()">
          <div class="items-grid-view vx-row match-height" v-if="matchList.length" appear>
              <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full" v-for="item in matchList" :key="item.objectID" :title="item.title">
                  <item-grid-view :item="item">
                      <!-- SLOT: ACTION BUTTONS -->
                      <template slot="action-buttons">
                          <div class="flex flex-wrap">

                              <!-- PRIMARY BUTTON : REMOVE -->
                              <div
                                  class="item-view-primary-action-btn p-3 flex flex-grow items-center justify-center cursor-pointer"
                                  @click="goToMatchDetail(item)">
                                  <feather-icon icon="ArrowRightCircleIcon" svgClasses="h-4 w-4" />

                                  <span class="ml-2">查看比赛</span>
                              </div>

                              <!-- SECONDARY BUTTON: MOVE TO CART -->
                              <div
                                  class="item-view-secondary-action-btn bg-primary p-3 flex flex-grow items-center justify-center text-white cursor-pointer"
                                  @click="goToMyMatchDetail(item)">
                                  <feather-icon icon="BoxIcon" svgClasses="h-4 w-4" />

                                  <span class="ml-2">查看作品</span>
                              </div>
                          </div>
                      </template>
                  </item-grid-view>
              </div>
          </div>

          <!-- IF NO ITEMS IN CART -->
          <div v-else v-show="!isLoading">
            <h4 :style="{marginBottom: '1.5rem'}">你好像还没有进行中的比赛喔～</h4>
            <vs-button :href="baseUrl">去报名</vs-button>
          </div>
        </vs-tab>
        <vs-tab :label="tabs[1]" :style="{padding:'30px 10px'}" @click="getList()">
          
          <div class="items-grid-view vx-row match-height" v-if="matchList.length" appear>
              <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full" v-for="item in matchList" :key="item.objectID" :title="item.title">
                  <item-grid-view :item="item">
                      <!-- SLOT: ACTION BUTTONS -->
                      <template slot="action-buttons">
                          <div class="flex flex-wrap">

                              <!-- PRIMARY BUTTON : REMOVE -->
                              <div
                                  class="item-view-primary-action-btn p-3 flex flex-grow items-center justify-center cursor-pointer"
                                  @click="goToMatchDetail(item)">
                                  <feather-icon icon="ArrowRightCircleIcon" svgClasses="h-4 w-4" />

                                  <span class="ml-2">查看比赛</span>
                              </div>

                              <!-- SECONDARY BUTTON: MOVE TO CART -->
                              <div
                                  class="item-view-secondary-action-btn bg-primary p-3 flex flex-grow items-center justify-center text-white cursor-pointer"
                                  @click="goToMyMatchDetail(item)">
                                  <feather-icon icon="FileTextIcon" svgClasses="h-4 w-4" />
                                  <span class="ml-2">查看报名</span>
                              </div>
                          </div>
                      </template>
                  </item-grid-view>
              </div>
          </div>

          <!-- IF NO ITEMS IN CART -->
          <div v-else v-show="!isLoading">
            <h4 :style="{marginBottom: '1.5rem'}">你报名比赛了吗，没有的话点击“去报名”参加比赛吧！</h4>
            <vs-button :href="baseUrl">去报名</vs-button>
          </div>
        </vs-tab>
        <vs-tab :label="tabs[2]" :style="{padding:'30px 10px'}" @click="getList()">
          <div class="items-grid-view vx-row match-height" v-if="matchList.length" appear>
              <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full" v-for="item in matchList" :key="item.objectID" :title="item.title">
                  <item-grid-view :item="item">
                      <!-- SLOT: ACTION BUTTONS -->
                      <template slot="action-buttons">
                          <div class="flex flex-wrap">

                              <!-- PRIMARY BUTTON : REMOVE -->
                              <div
                                  class="item-view-primary-action-btn p-3 flex flex-grow items-center justify-center cursor-pointer"
                                  @click="goToMatchDetail(item)">
                                  <feather-icon icon="ArrowRightCircleIcon" svgClasses="h-4 w-4" />

                                  <span class="ml-2">查看比赛</span>
                              </div>

                              <!-- SECONDARY BUTTON: MOVE TO CART -->
                              <div
                                  class="item-view-secondary-action-btn bg-primary p-3 flex flex-grow items-center justify-center text-white cursor-pointer"
                                  @click="goToMyMatchDetail(item)">
                                  <feather-icon icon="StarIcon" svgClasses="h-4 w-4" />

                                  <span class="ml-2">查看成绩</span>
                              </div>
                          </div>
                      </template>
                  </item-grid-view>
              </div>
          </div>

          <!-- IF NO ITEMS IN CART -->
          <div v-else v-show="!isLoading">
            <h4 :style="{marginBottom: '1.5rem'}">没有已结束的比赛喔-。-</h4>
            <vs-button :href="baseUrl">知道了， 去赛事页面看看。</vs-button>
          </div>
        </vs-tab>
      </vs-tabs>
      <div v-show="isLoading" id="div-with-loading" class="vs-con-loading__container w-1/5 h-24"></div>
    </vx-card>
  </div>
</template>

<script>
import { list } from "@/api/match";
import { getToken } from "@/utils/tools";
import config from '@/config'
const ItemGridView = () => import("./components/ItemGridView.vue");

export default {
  data() {
    return {
      matchList: [],
      tabs: ['进行中', '未开始', '已结束'],
      tabsIndex: 0,
      baseUrl: config.matchHost,
      loading: false,
    };
  },
  components: {
    ItemGridView,
  },
  computed: {
    listitems() {
      return this.matchList;
    },
    isLoading() {
      return this.loading
    }
  },
  methods: {
    getList() {
      this.openLoading(true)
      let that = this, status
      if (that.tabsIndex == 0) {
        status = 3
      } else if(that.tabsIndex == 1) {
        status = 2
      } else if(that.tabsIndex == 2) {
        status = 4
      }
      list({
        access_token: getToken(),
        status,
      }).then((res) => {
        const data = res.data;
        that.matchList = data.list;
        this.openLoading(false)
      });
    },
    goToMatchDetail(item) {
      window.open(item.url);
    },
    goToMyMatchDetail(item) {
      this.$router.push({path: '/match/detail', query: {id: item.id, tabsIndex:this.tabsIndex, tab:this.tabs[this.tabsIndex]}});
    },
    openLoading(type){
      if (type) {
        this.$vs.loading({
          container: '#div-with-loading',
          scale: 0.6
        })
        this.loading = true
      } else {
        this.$vs.loading.close("#div-with-loading > .con-vs-loading")
        this.loading = false
      }
    },
  },
  created() {
    this.tabsIndex = this.$route.query.tabsIndex ? this.$route.query.tabsIndex: 0
    
  },
  mounted() {
    this.getList()
  }
};
</script>

<style lang="scss" scoped>
#match-list {
  .item-view-primary-action-btn {
    color: #2c2c2c !important;
    background-color: #f6f6f6;
    min-width: 50%;
  }

  .item-view-secondary-action-btn {
    min-width: 50%;
  }
}
.vs-tabs-primary .activeChild button, .vs-tabs-primary button:not(:disabled):hover {
    color: #fff !important;
}
</style>
